import React from "react";

export default function RampsConfirmModal({
  open,
  onCancel,
  onConfirm,
  rows,
  quote,
  quoteLoading,
  quoteError,
  walletUsdt,
  sending,
}) {
  if (!open) return null;

  const totalUsdt = rows.reduce((a, r) => a + Number(r.amount || 0), 0);
  // Se há quote_amount no payload, prioriza esse valor; caso contrário calcula com price
  const estBrl =
    typeof quote?.quoteAmount === "number"
      ? quote.quoteAmount
      : quote?.price
      ? totalUsdt * Number(quote.price)
      : null;

  const excedeSaldo = totalUsdt > Number(walletUsdt || 0);
  const disableConfirm =
    sending || excedeSaldo || totalUsdt <= 0 || quoteLoading || !!quoteError;

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <style>{`
        .modal-backdrop{
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,.55);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }
        .modal{
          width: min(560px, 92vw);
          background: #151a2b;
          color: #e9edf5;
          border: 1px solid #21283d;
          border-radius: 16px;
          box-shadow: 0 12px 34px rgba(0,0,0,.5);
          padding: 20px;
        }
        .summary p{ margin: 6px 0; }
        .error{ color: #ff7675; }
        .muted{ color: #9aa4b2; }
        .actions{
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          margin-top: 16px;
        }
        .actions button{
          background: #1b2236;
          border: 1px solid #21283d;
          color: #e9edf5;
          border-radius: 10px;
          padding: 10px 14px;
          cursor: pointer;
        }
        .actions button:last-child{
          background: #39FF14;
          color: #0a0a0a;
          font-weight: 700;
          border: none;
        }
        .actions button[disabled]{
          opacity: .6;
          cursor: not-allowed;
        }
        .row{
          display:flex; gap:8px; align-items:baseline; flex-wrap:wrap;
        }
        .badge{
          display:inline-flex; align-items:center; gap:6px;
          border:1px solid #21283d; border-radius:999px; padding:4px 10px;
          font-size:12px; color:#9aa4b2;
        }
      `}</style>

      <div className="modal">
        <h3>Confirmar envios</h3>

        <div className="summary">
          <p>Total de destinatários: <b>{rows.length}</b></p>
          <p>Total a enviar (USDT): <b>{totalUsdt.toFixed(2)}</b></p>

          {/* Área de cotação */}
          <div className="row">
            <span className="badge">
              {quoteLoading && "Buscando cotação..."}
              {!quoteLoading && quote?.price && `Cotação USDT→BRL: ${Number(quote.price).toFixed(6)}`}
              {!quoteLoading && !quote?.price && !quoteError && "Cotação indisponível"}
              {quoteError && "Falha ao obter cotação"}
            </span>
          </div>

          {estBrl !== null && !quoteLoading && !quoteError && (
            <p>Estimado em BRL: <b>{Number(estBrl).toFixed(2)}</b></p>
          )}

          <p>Saldo atual (USDT): <b>{Number(walletUsdt || 0).toFixed(2)}</b></p>

          {excedeSaldo && (
            <p className="error">
              A soma ultrapassa o seu saldo. Ajuste os valores antes de confirmar.
            </p>
          )}
          {quoteError && (
            <p className="error">{quoteError}</p>
          )}
        </div>

        <div className="actions">
          <button onClick={onCancel} disabled={sending}>Cancelar</button>
          <button
            onClick={onConfirm}
            disabled={disableConfirm}
            title={quoteLoading ? "Aguardando cotação..." : undefined}
          >
            {sending ? "Enviando..." : "Confirmar e enviar"}
          </button>
        </div>
      </div>
    </div>
  );
}



